export const MINIMUM_SEND_SPEED = 1000;
export const MAXIMUM_SEND_SPEED = 300000;
export const STAGGER_EMAIL_SEND_SPEED = {
  REGULAR: 'regular',
  THROTTLE: 'throttle'
};
export const SEND_TIME_UNIT = {
  MINUTES: 'minutes',
  HOURS: 'hours'
};